import { CSS_VARIABLES } from "enums/cssVariables";
import styled from "styled-components";

export const BaseProposal = styled.button`
    width: 100%;
    display: block;
    /* Transparent over a background image (set by Layout), so unselected options show the frame. */
    background: var(
        ${CSS_VARIABLES.UNSELECTED_OPTION_BACKGROUND_COLOR},
        #ffffff
    );
    border: 1px solid grey;
    margin-bottom: 0.5rem;
    word-wrap: break-word;
    :hover {
        cursor: pointer;
    }
`;
